module.exports = [{"code":1,"name":"企业通行车辆"},{"code":2,"name":"临时通行车辆"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/carType.json
// module id = Mprb
// module chunks = 11